import { dateSchema } from '@optools/schemas/date';
import { Sport } from '@optools/services/operator-gateway/types/generated/graphql';
import { z } from 'zod';

export const milestonesScheduleSchema = dateSchema.extend({
  sport: z.enum(Sport).default(Sport.MLB),
});
